import { Link, useLocation } from 'react-router-dom';

export default function Breadcrumb() {
  const location = useLocation();
  const paths = location.pathname.split('/').filter(Boolean);

  const nameMap: Record<string, string> = {
    category: '分类',
    article: '文章',
    about: '关于我们',
    zuixin: '最新上线',
    remen: '热门推荐',
    hongtao: '红桃视频',
    yingtao: '樱桃视频',
    qiezi: '茄子视频',
    tangxin: '糖心视频',
    dianying: '电影',
    dianshiju: '电视剧',
    zongyi: '综艺',
    dongman: '动漫',
  };

  if (paths.length === 0) return null;

  const breadcrumbs = paths.map((path, index) => {
    const url = '/' + paths.slice(0, index + 1).join('/');
    const name = nameMap[path] || path;
    return { url, name };
  });

  return (
    <nav aria-label="面包屑导航" className="py-3 px-4 md:px-6 max-w-[1400px] mx-auto">
      <ol className="flex items-center flex-wrap gap-1 text-sm">
        <li>
          <Link
            to="/"
            className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
          >
            <i className="ri-home-4-line mr-1"></i>
            首页
          </Link>
        </li>
        {breadcrumbs.map((crumb, index) => (
          <li key={crumb.url} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            {index === breadcrumbs.length - 1 ? (
              <span className="text-foreground-700 font-medium whitespace-nowrap">
                {crumb.name}
              </span>
            ) : (
              <Link
                to={crumb.url}
                className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                {crumb.name}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}